import React, { Component, useState, useEffect } from 'react'

import { Link, useHistory } from 'react-router-dom';
import TextField from './../component/TextField'
import Select from 'react-select';
import ShareIcon from './../icons/ShareIcon'
import CloudStoreIcon from './../icons/cloudstoreicon'
import service from '../services'

//moment import
import moment from "moment";
import close from './../assets/images/close.svg'

//  Date Picker
import DatePicker from "react-datepicker";
import CalendarIcon from '../icons/calendaricon';

//redux
import { bindActionCreators } from 'redux';
import { ActCreators } from '../redux/bindActionCretor';
import { useSelector } from 'react-redux';
import { connect } from 'react-redux';

//import AWS from "aws-sdk";
import AWS from "aws-sdk";
import SimpleReactValidator from 'simple-react-validator';
import ModalMessage from '../component/ModalMessage';
import Loader from '../component/loader';
import ErrorPopUp from '../component/errorPopUp';
import FpgDisableIcon from '../icons/fpgdisableicon';
import FpgpublishIcon from '../icons/fpgpublishicon';
import FpgDeleteIcon from '../icons/fpgdeleteicon';
import PopUpCustomAll from '../component/fpg/create/popUpCustomAll';
import commonImage from '../commonImage';
import DropdownMaster from '../component/DropdownMaster';
import serachIcon from "../assets/images/search.svg";

let sub;
let CSV_TYPE = /\.(csv)$/i;
const mapDispatchToProps = dispatch => {
    return bindActionCreators(ActCreators, dispatch)
};
function AddPrivateEvents() {
    const history = useHistory();
    const [apiserve, setApiserve] = useState(new service());
    const _PrivateEventId = useSelector(state => state.PrivateEventId)
    const allInitial = useSelector(state => state.allInitial);
    const [showLocation, setShowLocation] = useState(false)
    const [time, setTime] = useState({
        startDateTime: new Date(),
        endDateTime: new Date(),
        // endDateTime: new Date(),
        hourSD: { value: '7', label: '7' },
        minSD: { value: '30', label: '30' },
        stampSD: { value: 'AM', label: 'AM' },
        hourED: { value: '7', label: '7' },
        minED: { value: '30', label: '30' },
        stampED: { value: 'AM', label: 'AM' },
    })
    const [eventData, setEventData] = useState({
        dateTime: {
            startTime: '',
            endTime: '',
            locationType: '1'
        },
        status: 1,
        _id: '',
        name: '',
        URL: '',
        joinURL: '',
        updatedBy: '',
        listLink: '',
        totalInvitee: 0,
        updatedAt: ''
    })
    const [validator, setValidator] = useState(new SimpleReactValidator({
        autoForceUpdate: this,
        validators: {
            urlValidation: {  // name the rule
                message: 'Please use a valid name of the :attribute',
                rule: (val, params, validator) => {
                    return validator.helpers.testRegex(val, /[(http(s)?):\/\/(www\.)?a-zA-Z0-9@:%._\+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_\+.~#?&//=]*)/) && params.indexOf(val) === -1
                },
                required: false  // optional
            },
        }
    }))
    const [inviteeList, setInviteeList] = useState([])
    const [fileUploading, setFileUploading] = useState(false)
    const [CSVfile, setCSVfile] = useState(null)
    const [urlFile, setUrlFile] = useState(null)
    const [successmodal, setSuccessmodal] = useState(false);
    const [messageModal, setMessageModal] = useState(false)
    const [loader, setLoader] = useState(false)
    const [errorPopup, setErrorPopup] = useState(false)
    const [inviteeModal, setInviteeModal] = useState(false)
    const [deleteEvent, setDeleteEvent] = useState(false)
    const [publishEvent, setPublishEvent] = useState(false)
    const [disableEvent, setDisableEvent] = useState(false)
    const [getLastUpdated, setGetLastUpdated] = useState('');
    const [errorMsg, setErrorMsg] = useState('')
    const [locations, setLocations] = useState([]);
    const [locationType, setlocationType] = useState([
        {
            id: 1,
            name: 'In-Person',
        },
        {
            id: 2,
            name: 'Online',
        },
    ]);
    const [emptyLocationError, setEmptyLocationError] = useState('')

    useEffect(() => {
        eventCall();
        apiserve.sendevent("fpg|privateEvent|getLastUpdated", { type: 1 })
        if (_PrivateEventId) {
            setLoader(true);
            apiserve.sendevent("fpg|privateEvent|getDetail", { eventId: _PrivateEventId })
        }
        return () => {
            if (sub) sub.unsubscribe()
        }
    }, [_PrivateEventId])

    useEffect(() => {
        if (allInitial && allInitial.location) {
            setLocations(allInitial.location.locations)
        }
    }, [allInitial])



    useEffect(() => {
        const csvFile = () => {
            if (CSV_TYPE.test(CSVfile.name)) {
                setTimeout(() => {
                    csvUpload(CSVfile);
                }, 0);
            } else {
                setErrorMsg('Please upload a file for CSV')
                setErrorPopup(true)
                setFileUploading(false)
            }
        }
        if (CSVfile) csvFile();
    }, [CSVfile])

    const eventCall = () => {
        sub = apiserve.getevent().subscribe((response) => {
            switch (response.event) {
                case "fpg|privateEvent|getDetail":
                    setLoader(false);
                    if (!response.error) {
                        const { data } = response;
                        data.map(data => {
                            // setEventData({
                            //     ...eventData,
                            //     status: data.status,
                            //     _id: data._id,
                            //     name: data.name,
                            //     URL: data.URL,
                            //     joinURL: data.joinURL,
                            //     updatedBy: data.updatedBy,
                            //     totalInvitee: data.totalInvitee,
                            //     listLink: data.S3InviteeURl,
                            //     updatedAt: data.updatedAt
                            // })
                            data.dateTime.map(datetime => {
                                setEventData({
                                    ...eventData,
                                    dateTime: {
                                        startTime: datetime.startTime,
                                        endTime: datetime.endTime,
                                        locationType: datetime.locationType,
                                        locations: datetime.locations.length > 0 ? getLocations(datetime.locations) : datetime.locations
                                    },
                                    status: data.status,
                                    _id: data._id,
                                    name: data.name,
                                    URL: data.URL,
                                    joinURL: data.joinURL,
                                    updatedBy: data.updatedBy,
                                    totalInvitee: data.totalInvitee,
                                    listLink: data.S3InviteeURl,
                                    updatedAt: data.updatedAt
                                })
                                //start date time 
                                const yearSD = moment.tz(datetime.startTime, "US/Mountain").format('YYYY')
                                const monthSD = moment.tz(datetime.startTime, "US/Mountain").format('MM') - 1
                                const dateSD = moment.tz(datetime.startTime, "US/Mountain").format('DD')
                                var StartDateTime = new Date(yearSD, monthSD, dateSD)

                                var hourSD = moment.tz(datetime.startTime, "US/Mountain").format('h');
                                var minSD = moment.tz(datetime.startTime, "US/Mountain").format('mm');
                                var stampSD = moment.tz(datetime.startTime, "US/Mountain").format('A');


                                const yearED = moment.tz(datetime.endTime, "US/Mountain").format('YYYY')
                                const monthED = moment.tz(datetime.endTime, "US/Mountain").format('MM') - 1
                                const dateED = moment.tz(datetime.endTime, "US/Mountain").format('DD')
                                var EndDateTime = new Date(yearED, monthED, dateED)

                                var hourED = moment.tz(datetime.endTime, "US/Mountain").format('h');
                                var minED = moment.tz(datetime.endTime, "US/Mountain").format('mm');
                                var stampED = moment.tz(datetime.endTime, "US/Mountain").format('A');

                                let stateTime = Object.assign({}, time);
                                stateTime.startDateTime = StartDateTime;
                                stateTime.endDateTime = EndDateTime;
                                stateTime.hourSD = { value: hourSD, label: hourSD }
                                stateTime.minSD = { value: minSD, label: minSD }
                                stateTime.stampSD = { value: stampSD, label: stampSD }
                                stateTime.hourED = { value: hourED, label: hourED }
                                stateTime.minED = { value: minED, label: minED }
                                stateTime.stampED = { value: stampED, label: stampED }
                                setTime(stateTime)
                            })
                            //inviteeList 
                            setInviteeList(data.inviteeList)
                        })
                    }
                    break;
                case 'fpg|privateEvent|getLastUpdated':
                    if (!response.error) {
                        setGetLastUpdated(response.data)
                    }
                    break;
                case "fpg|privateEvent|getEmailCsv":
                    if (!response.error) {
                        setLoader(false);

                        window.open(response.data.location)
                    }
                    else {

                        apiserve.error(response.data.error)
                    }
                    break;
                case "fpg|privateEvent|create":
                    if (!response.error) {
                        setLoader(false);
                        apiserve.success('Create Successfully.')
                        history.push("/private-events-list");
                    }
                    else {
                        setLoader(false);
                        setErrorPopup(true);
                        setErrorMsg(response.data.error);
                    }
                    break;
                case "fpg|privateEvent|update":
                    if (!response.error) {
                        setLoader(false);
                        apiserve.sendevent("fpg|privateEvent|getLastUpdated", { type: 1 })
                        apiserve.success('Update Successfully.')
                        history.push("/private-events-list");
                    }
                    else {

                        apiserve.error(response.data.error)
                    }
                    break;
                case "fpg|privateEvent|remove":
                    if (!response.error) {
                        setLoader(false);
                        history.push("/private-events-list");
                    }
                    else {
                        setLoader(false);
                        apiserve.error(response.data.error)
                    }
                    break;
                default:
                    break;
            }
        })
    }

    const handleTimeHours = (e, hour) => {
        let stateTime = Object.assign({}, time);
        if (hour === "hourSD") {
            stateTime.hourSD = e
        } else {
            stateTime.hourED = e
        }
        setTime(stateTime)
    }

    const handleTimeMin = (e, min) => {
        let stateTime = Object.assign({}, time);
        if (min === "minSD") {
            stateTime.minSD = e
        } else {
            stateTime.minED = e
        }
        setTime(stateTime)
    }

    const handleTimeStamps = (e, stamp) => {
        let stateTime = Object.assign({}, time);
        if (stamp === "stampSD") {
            stateTime.stampSD = e
        } else {
            stateTime.stampED = e
        }
        setTime(stateTime)
    }

    const handleDateChange = (e, name) => {
        let stateTime = Object.assign({}, time);
        if (name === "startDateTime") {
            stateTime.startDateTime = e
        } else {
            stateTime.endDateTime = e
        }
        setTime(stateTime)
    }

    //upload CSV
    const uploadCSV = (e) => {
        setFileUploading(true)
        let file = e.target.files[0];
        let reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onloadend = (event) => {
            setCSVfile(file)
            setUrlFile(event.target.result)
        };
    }

    const csvUpload = (file) => {

        var fileSet = commonImage(file,false,'',urlFile)
        fileSet.then((value) => {
            let stateEvent = Object.assign({}, eventData);
            stateEvent.listLink = encodeURI(process.env.REACT_APP_IMAGE_URL + value)
            setEventData(stateEvent);
            setFileUploading(false)
            apiserve.success(' File Uploaded Successfully.')
        });
    };

    //download CSV
    const downloadcsv = () => {
        if (eventData._id) {
            setLoader(true);
            apiserve.sendevent("fpg|privateEvent|getEmailCsv", { eventId: eventData._id });
        }
    }
    const getMtTime = (date) => {
        //Get offset from mountain time using UTC
        let ABBR = moment.tz("America/Denver").format("z");
        let offDifference = moment().utcOffset() + (ABBR === 'MDT' ? 360 : 420);

        // add that offset in date
        return moment(date).add(offDifference, 'minutes').toISOString()
    }
    const submit = () => {
        var locationError = false;
        if (eventData.dateTime.locationType === '1') {
            if (eventData.dateTime.locations && eventData.dateTime.locations.length !== 0) {
                locationError = false
                setEmptyLocationError('')
            } else {
                locationError = true
                setEmptyLocationError('Location is required.')
            }
        }
        if (validator.allValid() && locationError === false) {
            setLoader(true);

            var StartDateFinal = new Date(time.startDateTime);
            StartDateFinal.setHours(time.stampSD.value === 'PM' || time.stampSD.value === 'pm' ? parseInt(time.hourSD.value) === 12 ? parseInt(time.hourSD.value) : parseInt(time.hourSD.value) + 12 : parseInt(time.hourSD.value) === 12 ? parseInt(time.hourSD.value) - 12 : parseInt(time.hourSD.value), time.minSD.value);

            var EndDateFinal = new Date(time.endDateTime);
            EndDateFinal.setHours(time.stampED.value === 'PM' || time.stampED.value === 'pm' ? parseInt(time.hourED.value) === 12 ? parseInt(time.hourED.value) : parseInt(time.hourED.value) + 12 : parseInt(time.hourED.value) === 12 ? parseInt(time.hourED.value) - 12 : parseInt(time.hourED.value), time.minED.value);
            var data = {}
            if (eventData.dateTime.locationType === '1') {
                data = {
                    dateTime: {
                        ...eventData.dateTime,
                        startTime: getMtTime(StartDateFinal),
                        endTime: getMtTime(EndDateFinal),
                        locations: eventData?.dateTime?.locations?.length > 0 ? [eventData.dateTime?.locations[0] ?.value] : eventData.dateTime.locations ?.value ? [eventData.dateTime.locations ?.value] : []
                    },
                    status: eventData.status,
                    name: eventData.name,
                    URL: eventData.URL,
                    listLink: eventData.listLink ? eventData.listLink : "",
                }
            } else {
                data = {

                    dateTime: {
                        ...eventData.dateTime,
                        startTime: getMtTime(StartDateFinal),
                        endTime: getMtTime(EndDateFinal),
                        locations: eventData?.dateTime?.locations?.length > 0 ? [eventData.dateTime?.locations[0] ?.value] : eventData.dateTime.locations ?.value ? [eventData.dateTime.locations ?.value] : []
                    },
                    status: eventData.status,
                    name: eventData.name,
                    URL: eventData.URL,
                    joinURL: eventData.joinURL,
                    listLink: eventData.listLink ? eventData.listLink : "",
                }
            }
            if (eventData._id) data.eventId = eventData._id
            apiserve.sendevent(eventData._id ? "fpg|privateEvent|update" : "fpg|privateEvent|create", data)
        }
        else {
            setMessageModal(true)
            validator.showMessages();
        }
    }
    const onTextChange = (e) => {
        const { value, name } = e.target

        let stateEvent = Object.assign({}, eventData);
        stateEvent[name] = value.trimStart();
        setEventData(stateEvent);
    }
    const closeAdminUser = () => {
        setMessageModal(false);
        setDisableEvent(false)
        setDeleteEvent(false)
        setPublishEvent(false)
    };
    const disableDisablePopup = () => {
        let stateEvent = Object.assign({}, eventData);
        stateEvent.status = 2;
        setEventData(stateEvent);
        setDisableEvent(false)

    }
    const publishEventPopup = () => {
        let stateEvent = Object.assign({}, eventData);
        stateEvent.status = 1;
        setEventData(stateEvent);
        setPublishEvent(false)

    }
    const deleteEventPopup = () => {
        setDeleteEvent(false)
        setLoader(true);
        apiserve.sendevent("fpg|privateEvent|remove", { eventId: eventData._id })
    }
    const getLocations = (locations) => {
        return locations && locations.length > 0 && locations.map(item => {
            var location = {
                value: item._id, label: item.name, isSet: item.isSet, city: item.city, state: item.state
            }
            return location
        })
    }

    const handleEvent = (e) => {
        let { value, id } = e.target
        let stateEvent = Object.assign({}, eventData);
        if (value === 'In-Person') {
            stateEvent.dateTime['locationType'] = '1';
        } else if (value === 'Online') {
            stateEvent.dateTime['locationType'] = '2';
        }
        setEventData(stateEvent)
    }
    //Location Master Call
    const locationOption = () => {
        var options = []
        locations && locations.forEach(item => {
            if (item._id !== '934e67c906e26dd0737c')
                options.push({ value: item._id, label: item.name, isSet: item.isSet, city: item.city, state: item.state })
        });
        return options
    }

    const handleChangeLocation = (value) => {
        let stateEvent = Object.assign({}, eventData);
        if (value !== null || value && value.length !== 0) setEmptyLocationError('')
        else setEmptyLocationError('Location is required.')
        stateEvent.dateTime['locations'] = value;
        setEventData(stateEvent)
    }

    const hours = () => {
        return [
            { value: '12', label: '12' },
            { value: '1', label: '1' },
            { value: '2', label: '2' },
            { value: '3', label: '3' },
            { value: '4', label: '4' },
            { value: '5', label: '5' },
            { value: '6', label: '6' },
            { value: '7', label: '7' },
            { value: '8', label: '8' },
            { value: '9', label: '9' },
            { value: '10', label: '10' },
            { value: '11', label: '11' },
        ]
    }

    const minutes = () => {
        return [
            { value: '00', label: '00' },
            { value: '15', label: '15' },
            { value: '20', label: '20' },
            { value: '25', label: '25' },
            { value: '30', label: '30' },
            { value: '35', label: '35' },
            { value: '40', label: '40' },
            { value: '45', label: '45' },
            { value: '50', label: '50' },
            { value: '55', label: '55' },
        ]

    }

    const stamps = () => {
        return [
            { value: 'AM', label: 'AM' },
            { value: 'PM', label: 'PM' }
        ]
    }
    return (
        <React.Fragment>
            {loader && <Loader />}
            <div className="right_side_wrapper">
                <div className="">
                    <ul className="fpg_admin_tab disp_flex">
                        <li className="active">
                            <p className="text_left">
                                <div>Add / Edit Private Event </div>
                            </p>
                        </li>
                    </ul>
                </div>
                <div className="back_date d_flex d_flex_align_center d_flex_justify_spacebt">
                    <Link className="back_link" to='/private-events-list'> <svg width="5" height="10" viewBox="0 0 5 10" fill="none"><path d="M5 0L0 5L5 10V0Z" fill="black" /> </svg> Back To List</Link>
                    {eventData._id && <p className="update_date">
                        Last Update: {moment(getLastUpdated.updatedAt).tz("US/Mountain").format("h:mm A")}{' '}
                        PT- {moment.tz(getLastUpdated.updatedAt, "US/Mountain").format('MM/DD/YYYY')}-
                        Last Updated By:{getLastUpdated.updatedBy && `${getLastUpdated.updatedBy.fname}${' '} ${getLastUpdated.updatedBy.lname}`}
                    </p>}
                </div>
                <div className="fpg_tabcontent pl_15 fpg_create_film">
                    {eventData._id &&
                        <>
                        <div className="fpg_edits_links d_flex d_flex_align_center d_flex_justify_end">
                            {eventData.status === 1
                                ? <Link className="d_flex d_flex_align_center d_flex_justify_center" onClick={() => setDisableEvent(true)} >
                                    <FpgDisableIcon /> DISABLE
                                    </Link>
                                : <Link className="d_flex d_flex_align_center d_flex_justify_center" onClick={() => setPublishEvent(true)} >
                                    <FpgpublishIcon /> PUBLISH
                                    </Link>}
                            <Link className="d_flex d_flex_align_center d_flex_justify_center" onClick={() => setDeleteEvent(true)} >
                                <FpgDeleteIcon /> DELETE
                                </Link>
                        </div>
                        </>}
                    <form>
                        <div className="private_event_wrap">
                            <div className="field_row horizontal_field">
                                <TextField label="Event Name" type="text" value={eventData.name} name="name" placeholder="Sony Classics" onChange={(e) => onTextChange(e)} fpgerror={validator.message('name', eventData.name, 'required')} />
                            </div>
                            <div className="field_row horizontal_field">
                                <div className="field_row_inner">
                                    <label>Event Date-Time (MT)</label>
                                    <div className="event_start_end d_flex">
                                        <div className="start_date field_input">
                                            <p className="mb_10 date_label text_center">Start Date-Time (MT)</p>
                                            <div className="feature_date_time">
                                                <div className="field_row">

                                                    <div className="field_row">
                                                        <div className="form_group form_group_input textfield_add_remove d_flex d_flex_align_center">
                                                            <div className="form_group_inner d_flex mb_0 horizontal_field d_flex_align_center">
                                                                <div className="form_group_countdown disp_flex d_flex_align_center">
                                                                    <TextField type="text" name="startDateTime"
                                                                        value={moment(time.startDateTime).format("MM/DD/YYYY")}
                                                                        placeholder="mm / dd / yyyy"
                                                                    />

                                                                    <span className="calendar_img">
                                                                        <DatePicker
                                                                            selected={time.startDateTime}
                                                                            onChange={(e) => handleDateChange(e, "startDateTime")}
                                                                            minDate={moment().toDate()}
                                                                            placeholder="mm/dd/yyyy"
                                                                            customInput={
                                                                                <span className="calendar">
                                                                                    <CalendarIcon />
                                                                                </span>
                                                                            }
                                                                        />
                                                                    </span>

                                                                    <Select
                                                                        options={hours()}
                                                                        value={time.hourSD}
                                                                        name='hours'
                                                                        placeholder="7"
                                                                        onChange={(e) => handleTimeHours(e, "hourSD")}
                                                                    />
                                                                    <Select
                                                                        options={minutes()}
                                                                        value={time.minSD}
                                                                        name='minutes'
                                                                        placeholder="30"
                                                                        onChange={(e) => handleTimeMin(e, "minSD")}
                                                                    />
                                                                    <Select
                                                                        options={stamps()}
                                                                        value={time.stampSD}
                                                                        name='state'
                                                                        placeholder="AM"
                                                                        onChange={(e) => handleTimeStamps(e, "stampSD")}
                                                                    />
                                                                </div>

                                                            </div>
                                                        </div>
                                                    </div>

                                                </div>
                                            </div>
                                        </div>
                                        <div className="end_date field_input">
                                            <p className="mb_10 date_label text_center">End Date-Time (MT)</p>
                                            <div className="feature_date_time">
                                                <div className="field_row">

                                                    <div className="field_row">
                                                        <div className="form_group form_group_input textfield_add_remove d_flex d_flex_align_center">
                                                            <div className="form_group_inner d_flex mb_0 horizontal_field d_flex_align_center">
                                                                <div className="form_group_countdown disp_flex d_flex_align_center">
                                                                    <TextField type="text" name="endDateTime"
                                                                        value={moment(time.endDateTime).format("MM/DD/YYYY")}
                                                                        placeholder="mm / dd / yyyy"
                                                                    />

                                                                    <span className="calendar_img">
                                                                        <DatePicker
                                                                            selected={time.endDateTime}
                                                                            onChange={(e) => handleDateChange(e, "endDateTime")}
                                                                            minDate={new Date(moment(time.startDateTime))}
                                                                            placeholder="mm/dd/yyyy"
                                                                            customInput={
                                                                                <span className="calendar">
                                                                                    <CalendarIcon />
                                                                                </span>
                                                                            }
                                                                        />
                                                                    </span>

                                                                    <Select
                                                                        options={hours()}
                                                                        value={time.hourED}
                                                                        name='hours'
                                                                        placeholder="7"
                                                                        onChange={(e) => handleTimeHours(e, "hourED")}
                                                                    />
                                                                    <Select
                                                                        options={minutes()}
                                                                        value={time.minED}
                                                                        name='minutes'
                                                                        placeholder="30"
                                                                        onChange={(e) => handleTimeMin(e, "minED")}
                                                                    />
                                                                    <Select
                                                                        options={stamps()}
                                                                        value={time.stampED}
                                                                        name='state'
                                                                        placeholder="AM"
                                                                        onChange={(e) => handleTimeStamps(e, "stampED")}
                                                                    />
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>

                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="field_row horizontal_field d_flex ">
                                <div className="field_row_inner d_flex_align_center">
                                    <label></label>
                                    <DropdownMaster
                                        name="locationType"
                                        selectedDrop={true}
                                        value={eventData && eventData.dateTime.locationType === '1' ? 'In-Person' : 'Online'}
                                        options={locationType}
                                        onChange={(e) => handleEvent(e)}
                                    />
                                </div>
                                {eventData.dateTime.locationType === '1' &&
                                    <div className=" ml_25 d_flex_align_center ">
                                        <div className="field_row_inner d_flex_align_center">
                                            <label>Location</label>
                                            <div className="select_field relative  sd_private_location">
                                                <Select
                                                    // isMulti
                                                    onChange={(e) => handleChangeLocation(e)}
                                                    options={locationOption()}
                                                    value={eventData.dateTime.locations}
                                                />
                                            </div>

                                            {emptyLocationError &&
                                                <span className="error srv-validation-message w_100 " style={{ color: 'red', marginLeft: 125 }}>{emptyLocationError}</span>
                                            }
                                        </div>


                                    </div>
                                }
                            </div>
                            <div className="field_row horizontal_field">
                                <TextField label="Event Details URL" type="text" value={eventData.URL} placeholder="https://" name="URL" onChange={(e) => onTextChange(e)}
                                    fpgerror={validator.message('url', eventData.URL, 'required|url')} />
                            </div>
                            {eventData.dateTime.locationType === '2' &&
                                <div className="field_row horizontal_field">
                                    <TextField label="Join Event URL" type="text" value={eventData.joinURL} placeholder="https://" name="joinURL" onChange={(e) => onTextChange(e)}
                                        fpgerror={validator.message('join url', eventData.joinURL, 'required|url')} />
                                </div>
                            }

                            <div className="field_row horizontal_field">
                                <div className="field_row_inner d_flex_align_center">
                                    <label>Invitee List</label>
                                    <div className="field_input relative disp_flex d_flex_justify_spacebt d_flex_align_center">
                                        <h3 className="font_500 color_blue">{eventData.totalInvitee}</h3>
                                        <div className="disp_flex d_flex_align_center invitee_btns">
                                            {eventData._id && <span className="uppercase" onClick={() => setInviteeModal(true)}>VIEW</span>}

                                            <span className="uppercase upload_csv_invitee relative pointer">
                                                <input type="file" name="file" accept=".csv" onChange={(e) => uploadCSV(e)} />
                                                UPLOAD CSV
                                                    {fileUploading &&
                                                    <img src="data:image/gif;base64,R0lGODlhEAAQAPIAAP///wAAAMLCwkJCQgAAAGJiYoKCgpKSkiH/C05FVFNDQVBFMi4wAwEAAAAh/hpDcmVhdGVkIHdpdGggYWpheGxvYWQuaW5mbwAh+QQJCgAAACwAAAAAEAAQAAADMwi63P4wyklrE2MIOggZnAdOmGYJRbExwroUmcG2LmDEwnHQLVsYOd2mBzkYDAdKa+dIAAAh+QQJCgAAACwAAAAAEAAQAAADNAi63P5OjCEgG4QMu7DmikRxQlFUYDEZIGBMRVsaqHwctXXf7WEYB4Ag1xjihkMZsiUkKhIAIfkECQoAAAAsAAAAABAAEAAAAzYIujIjK8pByJDMlFYvBoVjHA70GU7xSUJhmKtwHPAKzLO9HMaoKwJZ7Rf8AYPDDzKpZBqfvwQAIfkECQoAAAAsAAAAABAAEAAAAzMIumIlK8oyhpHsnFZfhYumCYUhDAQxRIdhHBGqRoKw0R8DYlJd8z0fMDgsGo/IpHI5TAAAIfkECQoAAAAsAAAAABAAEAAAAzIIunInK0rnZBTwGPNMgQwmdsNgXGJUlIWEuR5oWUIpz8pAEAMe6TwfwyYsGo/IpFKSAAAh+QQJCgAAACwAAAAAEAAQAAADMwi6IMKQORfjdOe82p4wGccc4CEuQradylesojEMBgsUc2G7sDX3lQGBMLAJibufbSlKAAAh+QQJCgAAACwAAAAAEAAQAAADMgi63P7wCRHZnFVdmgHu2nFwlWCI3WGc3TSWhUFGxTAUkGCbtgENBMJAEJsxgMLWzpEAACH5BAkKAAAALAAAAAAQABAAAAMyCLrc/jDKSatlQtScKdceCAjDII7HcQ4EMTCpyrCuUBjCYRgHVtqlAiB1YhiCnlsRkAAAOwAAAAAAAAAAAA==" />}
                                            </span>

                                        </div>
                                    </div>
                                    {eventData._id &&
                                        <span className="pointer cloud_icon" onClick={() => downloadcsv()}><CloudStoreIcon /></span>
                                    }
                                </div>
                            </div>
                        </div>
                        <div className="text_center field_row w_100 buttons_outer mb_0">
                            <button className="uppercase mb_0" type="button" onClick={() => history.push("/private-events-list")}>CANCEL</button>
                            <button className="uppercase active mb_0" type="button" onClick={() => submit()} >SAVE</button>
                        </div>
                    </form>
                </div>

                {/* show invite List model */}
                {inviteeModal &&
                    <div className="delete_popup_wrapper">
                        <div className="popup_inner">
                            <h2 className="popup_title relative text_center">
                                Invitee List
                                    <img src={close} onClick={() => setInviteeModal(false)} />
                            </h2>
                            <div className="details invitee_detail pb_15">
                                {inviteeList && inviteeList.map((item, i) => (
                                    <p>{item}</p>
                                ))}
                            </div>
                        </div>
                    </div>
                }
                {/* For CSV upload successfully */}
                <div className={`user_popup ${successmodal ? "active" : null}`}>
                    <span className="popup_overlay" onClick={() => setSuccessmodal(false)}></span>
                    <div className="sundance_popup_detail box_shadow approve_success_popup bg_white">
                        <div className="approve_popup_header text_center relative">
                            <p>You have successfully uploaded {inviteeList.length} users</p>
                        </div>
                        <div className="content">
                            <div className="field_row text_center">
                                <button className="small_btn active" onClick={() => setSuccessmodal(false)}>OK</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {errorPopup &&
                <ErrorPopUp
                    errorMsg={errorMsg}
                    errorMsgPopup={() => setErrorPopup(false)}
                />
            }
            {publishEvent &&
                <PopUpCustomAll
                    HeaderName='Publish Changes'
                    insideDetails='Saving the current changes will publish it to the production site'
                    insideData='Do you want to proceed?'
                    popupState={() => closeAdminUser()}
                    yesPopUp={() => publishEventPopup()}
                />
            }
            {deleteEvent
                && <PopUpCustomAll
                    HeaderName='Delete?'
                    insideDetails='You are about to delete an item and this action is permanent'
                    insideData='Do you want to proceed?'
                    popupState={() => closeAdminUser()}
                    yesPopUp={() => deleteEventPopup()} />
            }
            {disableEvent &&
                <PopUpCustomAll
                    HeaderName='Disable?'
                    insideDetails='You are about to disable an item, which will temporarily make it unavailable on the production site'
                    insideData='Do you want to proceed?'
                    popupState={() => closeAdminUser()}
                    yesPopUp={() => disableDisablePopup()} />
            }
        </React.Fragment>
    )
}
export default connect(null, mapDispatchToProps)(AddPrivateEvents)